module.exports = __webpack_public_path__ + "static/img/no-search-data.7599fbca.png";